import {
  Row,
  Col,
  Card,
  Table,
  Typography,
  notification,
  Input,
  Button
} from "antd";
import { SearchOutlined } from "@ant-design/icons";


// Images
import { useEffect, useState } from "react";
import { getCustomers } from "../api/booking.service";

const { Title } = Typography

function Customers() {

  // Helper function to add search functionality for a column
  const getColumnSearchProps = (dataIndex, placeholder, renderField) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${placeholder}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => confirm()}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => confirm()}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => clearFilters()}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      const recordValue = renderField ? renderField(record) : record[dataIndex];
      return recordValue
        ? recordValue.toString().toLowerCase().includes(value.toLowerCase())
        : false;
    },
  });

  const columns = [
    {
      title: "CUSTOMER NAME",
      dataIndex: "name",
      key: "name",
      width: "33%",
      ...getColumnSearchProps("name", "Customer Name", (record) => record.name),
      render: (text, record) => (
        <div>
          <Title level={5}>{record.name}</Title>
        </div>
      ),
    },
    {
      title: "CUSTOMER EMAIL",
      dataIndex: "email",
      key: "email",
      width: "34%",
      ...getColumnSearchProps("email", "Customer Email", (record) => record.email),
      render: (text, record) => (
        <div>
          <Title level={5}>{record.email}</Title>
        </div>
      ),
    },
    {
      title: "CUSTOMER PHONE",
      dataIndex: "phone",
      key: "phone",
      width: "33%",
      ...getColumnSearchProps("phone", "Customer Phone", (record) => record.phone),
      render: (text, record) => (
        <div>
          <Title level={5}>{record.phone}</Title>
        </div>
      ),
    },
  ];

  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchVehicles = async () => {
    try {
      setLoading(true);
      const data = await getCustomers();
      setVehicles(data?.data || []); // Set the fetched vehicles data
    } catch (err) {
      notification.error({ message: 'Failed to fetch vehicles' });
      setError('Failed to fetch vehicles');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicles();
  }, []);

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Customers Table"
            >
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={vehicles}
                  pagination={{
                    pageSize: 100
                  }}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Customers;
